var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhyfintoo5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5251 2.59487C19.111 2.00894 19.111 1.05737 18.5251 0.471436C17.9391 -0.114502 16.9876 -0.114502 16.4016 0.471436L1.40161 15.4714C0.815674 16.0574 0.815674 17.0089 1.40161 17.5949C1.98755 18.1808 2.93911 18.1808 3.52505 17.5949L18.5251 2.59487ZM6.96567 3.0355C6.96567 2.23985 6.6496 1.47679 6.08699 0.914177C5.52439 0.351568 4.76132 0.0354979 3.96567 0.0354979C3.17002 0.0354979 2.40696 0.351568 1.84435 0.914177C1.28174 1.47679 0.965674 2.23985 0.965674 3.0355C0.965674 3.83115 1.28174 4.59421 1.84435 5.15682C2.40696 5.71943 3.17002 6.0355 3.96567 6.0355C4.76132 6.0355 5.52439 5.71943 6.08699 5.15682C6.6496 4.59421 6.96567 3.83115 6.96567 3.0355ZM18.9657 15.0355C18.9657 14.2399 18.6496 13.4768 18.087 12.9142C17.5244 12.3516 16.7613 12.0355 15.9657 12.0355C15.17 12.0355 14.407 12.3516 13.8444 12.9142C13.2817 13.4768 12.9657 14.2399 12.9657 15.0355C12.9657 15.8311 13.2817 16.5942 13.8444 17.1568C14.407 17.7194 15.17 18.0355 15.9657 18.0355C16.7613 18.0355 17.5244 17.7194 18.087 17.1568C18.6496 16.5942 18.9657 15.8311 18.9657 15.0355Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhyfintoo5);
export default __webpack_public_path__ + "static/media/whyfintoo5.b0d983566e74788d37cdfa6bb53b06e9.svg";
export { ForwardRef as ReactComponent };